import { supabase } from '../../../integrations/supabase/client';

const MONTHLY_PLAN_LIMIT = 10000;

export async function getConsumePlan() {
  const { data: { user } } = await supabase.auth.getUser();
  if (!user) {
    return { percentage: 0, used: 0, limit: MONTHLY_PLAN_LIMIT };
  }

  const startOfMonth = new Date();
  startOfMonth.setDate(1);
  startOfMonth.setHours(0, 0, 0, 0);

  const { count } = await supabase
    .from('lead_messages')
    .select('*', { count: 'exact', head: true })
    .eq('user_id', user.id)
    .gte('created_at', startOfMonth.toISOString());

  const used = count ?? 0;
  const percentage = Math.min(Math.round((used / MONTHLY_PLAN_LIMIT) * 100), 100);

  return { percentage, used, limit: MONTHLY_PLAN_LIMIT };
}

export async function getAgentCostRanking() {
  try {
    const { data, error } = await supabase.functions.invoke('openrouter-usage');

    if (error || !data?.data) return [];

    const keys = data.data as {
      name: string;
      hash: string;
      usage_total: number;
      usage_daily: number;
      usage_weekly: number;
      usage_monthly: number;
    }[];

    return keys
      .filter((k) => k.usage_monthly > 0 || k.usage_total > 0)
      .map((k) => ({
        name: k.name,
        conversations: 0,
        estimatedCost: k.usage_monthly < 0.01
          ? k.usage_monthly.toFixed(4)
          : k.usage_monthly.toFixed(2),
        usageTotal: k.usage_total,
        usageDaily: k.usage_daily,
      }));
  } catch {
    return [];
  }
}
